<zag-card variant="interactive" (cardClick)="onCardClick()">
  <!-- Header: Icon/Color, Name and optional Delete button -->
  <div card-header class="zag-team-card__header">
    <div
      class="zag-team-card__icon-wrapper zag-icon-surface-gradient"
      [class.zag-team-card__icon-wrapper--fallback]="!team().color"
      [style.background-color]="team().color || null"
    >
      <span [zagIcon]="team().icon || 'groups'" [style.color]="getIconColor(team().color)" class="zag-team-card__icon"></span>
    </div>
    <div class="zag-team-card__text">
      <h3 class="zag-card-title">{{ team().name }}</h3>
    </div>
    @if (showDelete()) {
    <button
      type="button"
      class="zag-team-card__delete-btn"
      [disabled]="deleteDisabled()"
      [attr.aria-label]="deleteAriaLabel() || null"
      (click)="onDeleteClick($event)"
    >
      <span zagIcon="delete"></span>
    </button>
    }
  </div>

  <!-- Body: Description -->
  @if (team().description) {
  <p class="zag-team-card__description">{{ team().description }}</p>
  }
</zag-card>
